import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { itemValue } from './_models/itemValue';
import { menuItem, menuType } from './_models/menuItem';
import { JarvisPopupService } from '../jarvis-popup/jarvis-popup.service';
import { SmagAccountService } from '../../framework/auth/services/index';
import { User } from '../../_models/index';
import { groupItem } from './_models';
import { EventEmitterService, FarmServices, HandleService, PrecizionServices } from '../../_services';

@Component({
  selector: 'app-jarvis-ui',
  templateUrl: './jarvis-ui.component.html',
  styleUrls: ['./assets/font/style.css', './jarvis-ui.component.scss', './jarvis-ui.component.responsive.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class JarvisUiComponent implements OnInit {

  /**
   * Affiche le filtre sur ecrans responsive
   */
  public showPopupFilter = false;
  /**
   * Affiche le menu profil sur ecrans responsive
   */
  public showMenuProfil = false;
  public showSmagButton = true;
  /**
   * Indique si la fonctionnalité "Devices" est disponible (si une URL est fournie)
   */
  public devicesAvailable = false;

  /**
   * Event émis lors du clic sur le bouton "Devices" pour ouvrir la modale correspondante
   */
  @Output()
  public devicesClick: EventEmitter<void> = new EventEmitter<void>();

  // Permet de savoir si l'input de recherche doit être affiché
  public searchInputVisible: boolean = false;

  // Profils et roles Smag autorisés pour afficher l'input de recherche
  private searchAllowedProfilesAndRoles = ['initiator', 'initiateur', 'technician', 'technicien', 'agentbeapi'];

  // le code propre au menu filtre exploitations
  private _codeFarmMenu='farm';

   // le code propre au menu filtre exploitations
  public get MenuFarmCode():string{
    return this._codeFarmMenu;
  }

  // Terme de recherche par menu
  public searchTerms: { [key: string]: string } = {};

  //css de l'icone des export connectés
  public classExportConnectedState = '';


  //tooltip sur icone des exports de console connectées
  public IconConnectedStatesTitle: string = "Visualiser l'historique des exports connectés";
  //Indique si il dispose de statut d'exports connectés
  private includeConnectedStates: boolean | null = null;
  //tooltip sur icone de suppression de selection du groupe exploitation
  public IconDeleteFarmSelectionTitle: string ="Supprimer la sélection"

  @Input()
  public CoopName: string ="";

  @Input()
  public ImageUrl: string ="";

  @Input()
  public User: User = new User();
  //les menus
  private _menus: menuItem[] = [];

  // Map contenant les IDs des éléments préselectionnés pour chaque menu.
  private _initialCheckedMultiMenus: Map<string, string[]> = new Map();
  // comporend par menu le nombre maximum d'éléments sélectionnables
  private _limitedSelectionMultiMenus: Map<string, number> = new Map();
  
  private _currentGroupCoopSelected:string|null = null;

  /**liste des menus mobile collapsed */
  public collapsedMenus: { [key: string]: boolean } = {};

    /**liste des menus avec changement non appliqué */
  public changedMenus: { [key: string]: boolean } = {};

  /**indique si il est en mode mobile au chargement */
  public IsMobile:boolean|null=null;

  /**
   * Indique si la limite de sélection pour un menu et un groupe donnés a été atteinte.
   * @param menuCode 
   * @param group 
   * @returns 
   */
  public IsLimitSelectionReached(menuCode: string, group:any): boolean {
   
    const limit = this._limitedSelectionMultiMenus.get(menuCode);
    if (limit === undefined) return false;

    if(group != null && group.Id != this._currentGroupCoopSelected) {
      //pour le groupe passé n est pas concerné par la limite de sélection
      return false;
    }
    
    const checkedCount = this.Selected(menuCode) ?? 0;
    return checkedCount >= limit;
  }
  
  get Menus(): menuItem[] {
    return this._menus;
  }
// recoit le smenu générés
  @Input()
  set Menus(value: menuItem[]) {
    this._menus = value;
    this.BindInitialCheckedMenu();
  }

  /**
   * Initialisation de la liste des id préselectionnés au chargement de la page.
   */
  private BindInitialCheckedMenu() {

    
    this._currentGroupCoopSelected= null;
    
    this._initialCheckedMultiMenus.clear();
    this._menus.forEach((menu, index) => {
      if(menu == null || menu.Checkable != menuType.MultiSelectable) return;
      const checkedIndices: string[] = [];
      if(menu.MultiMaxSelectable && menu.MultiMaxSelectable > 0){
        this._limitedSelectionMultiMenus.set(menu.Code, menu.MultiMaxSelectable);
      }
      menu.GroupItems.forEach((group, groupIndex) => {
       
        group.Items.forEach((item, itemIndex) => {
          if (item.Checked) {
             
           this._currentGroupCoopSelected = group.Id;
            checkedIndices.push(item.Id);
          }
        });
      });
      this._initialCheckedMultiMenus.set(menu.Code, checkedIndices);
      
    });
    this.IsMobile = HandleService.isMobile()>0;

  }

  @Output()
  public logout: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output()
  public SelectionChanged: EventEmitter<menuItem> = new EventEmitter<menuItem>();
  @Output()
  public ActionClick: EventEmitter<itemValue> = new EventEmitter<itemValue>();

  @Output()
  public OtherActionClick: EventEmitter<itemValue> = new EventEmitter<itemValue>();
  @Input()
  public DevicesUrl: string = '';

  @Input()
  menuWith?(): string {
    return (100 / (this.Menus.length - 1)) + "%";
  }

  @Input()
  ActionMenus?(): menuItem[] {
    return this.Menus.filter(i => i.Checkable == menuType.Action);
  }
  @Input()
  FilterMenus?(): menuItem[] {
    return this.Menus.filter(i => i.Checkable != menuType.Action && i.Visible);
  }

  @Input()
  allItems(menu: menuItem|undefined) {
    var items: Array<itemValue> = new Array<itemValue>();

    if(menu){
      menu.GroupItems.forEach(g => {
        items = items.concat(g.Items);
      });
    }
    return items;
  }


  /**
   * Retourne le nombre de records sélectionnés pour un menu donné.
   * @param code  Le code du menu pour lequel on souhaite connaître le nombre de sélections.
   * @returns  Le nombre d'éléments sélectionnés pour le menu spécifié.
   */
  @Input()
  Selected(code: string): number {

    return this.allItems(this.Menus.find(m => m.Code == code)).filter(i => i.Checked).length;
  }

  /**
   * retourne le nombre total d'éléments pour un menu donné.
   * @param code  Le code du menu pour lequel on souhaite connaître le nombre total d'éléments.
   * @returns  Le nombre total d'éléments pour le menu spécifié.
   */
    @Input()
  CountRecords?(code: string): number {

    return this.allItems(this.Menus.find(m => m.Code == code))?.length;
  }

  /**
   * Retourne le texte de l'élément sélectionné pour un menu donné.
   * @param code  Le code du menu pour lequel on souhaite obtenir le texte de l'élément sélectionné.
   * @returns  Le texte de l'élément sélectionné pour le menu spécifié.
   */
  @Input()
  SelectedText?(code: string): string {
    return this.allItems(this.Menus.find(m => m.Code == code)).filter(i => i.Checked)[0].Value;
  }


  constructor(private popupService: JarvisPopupService, private smagAccountService: SmagAccountService, private farmService: FarmServices, private eventEmitterService: EventEmitterService, private precizionExport: PrecizionServices) {
  }

  ngOnInit() {
    this.collapsedMenus={};
    this.changedMenus={};
    this.User = new User();
    this.smagAccountService.loadSmagButtonLibraries();
    this.initializeSearchTerms();
    this.checkDevicesAvailability();
    this.initCanShowSearchInput();
    // Lorsqu'on clique sur le bouton d'affichage des groupes, si le popup filter est ouvert, on le ferme
    this.eventEmitterService.onTogglePopupGroupClick().subscribe((isOpened: boolean) => {
      if (isOpened) {
        this.showPopupFilter = false;
      }
    });
    this.updateExportConnectedStateFlash();
    this.IsMobile = HandleService.isMobile()>0;
  }

  private checkDevicesAvailability(): void {
    this.devicesAvailable = !!this.DevicesUrl;
  }

  public get IncludeConnectedStates() {
    if (!this.includeConnectedStates)
      this.includeConnectedStates = this.precizionExport.ExistExportStateConnectedDevices() == true;
    return this.includeConnectedStates;
  }

  /**
   * Initialise la visibilité de l'input de recherche en fonction des profils et rôles autorisés.
   * vérifie d'abord le rôle via farmService, puis le profil via smagAccountService.
   */
  private initCanShowSearchInput(): void {
    // Initialiser à false par défaut
    this.searchInputVisible = false;

    // Vérifier d'abord le rôle via farmService
    this.farmService.getuserinfo().subscribe((userInfo: User) => {
      if (userInfo && userInfo.Role && this.searchAllowedProfilesAndRoles.includes(userInfo.Role)) {
        this.searchInputVisible = true;
        return;
      }

      // Si pas d'autorisation via le rôle, vérifier le profil
      const smagUser = this.smagAccountService.getSmagUser();
      if (smagUser && smagUser.profile) {
        this.searchInputVisible = this.searchAllowedProfilesAndRoles.includes(smagUser.profile);
      }
    });
  }

  /**
   * Initialise les termes de recherche pour chaque menu.
   * parcourt tous les menus et initialise un terme de recherche vide pour chaque menu.
   */
  private initializeSearchTerms(): void {
    this.searchTerms = {};
    if (this.Menus) {
      this.Menus.forEach(menu => {
        this.searchTerms[menu.Code] = '';
      });
    }
  }

  /**
   * Event surclic mobile application de selection de filtres
   * @param event event
   * @param menuCode menu code
   */
  public onClickApplyFilterSelection(event: any, menuCode: string|null){
    this.onMouseLeaveFilter(event,menuCode,'ApplyFilterSelection')
  }
  /**
   * Event sur sortie de la souris du composant menu selectionné
   * @param event event
   * @param menuCode code du menu actuel
   * @param codeEventType code event
   * @returns 
   */
  public onMouseLeaveFilter(event: any, menuCode: string|null, codeEventType:string) {
    
    if(this.IsMobile && codeEventType !== 'ApplyFilterSelection'){
      return;
    }
   event.currentTarget.scrollTop = 0;
  
    if(menuCode){
      var activMenu = this.Menus.find(x => x.Code === menuCode);
     
        if (!activMenu) {

          return;
        }else if(activMenu.Checkable == menuType.MultiSelectable) {

          let initialSelection = this._initialCheckedMultiMenus.get(activMenu.Code);
          let ifinalSelection = this.allItems(activMenu).filter(i => i.Checked);
         
          if(initialSelection?.length == 0 && ifinalSelection?.length == 0) {
              //aucun selection on propage pas
              this._currentGroupCoopSelected = null;
          }else{
            
            //au moins une selection on contrôle si changement
            if(initialSelection?.length != ifinalSelection?.length) {
            
              this.EmitMenuSelectionChanges(activMenu);
             

            }else{
              //meme nombre mais controle les ids changes
              let initialIds = initialSelection.sort();
              let finalIds = ifinalSelection?.map(i => i.Id).sort();
                
              if(JSON.stringify(initialIds) != JSON.stringify(finalIds)) {
                 
                this.EmitMenuSelectionChanges(activMenu);
              }
            }
          }
          //on refresh la liste des selection de menu
          this.BindInitialCheckedMenu();
        }
    }
   
  }


  public selectAllClick(event: any) {
    var code = event.target.id.split("_")[1];
    var activMenu = this.Menus.find(x => x.Code === code);
    if(!activMenu) {
      return;
    }
    var check = (this.allItems(activMenu).filter(x => x.Checked == false).length == 0);

    this.allItems(activMenu).forEach(itemmenu => {
      itemmenu.Checked = !check;
    });
    this.EmitMenuSelectionChanges(activMenu);
  }

  public itemActionClick(code: string, itemId: string) {

    var activMenu = this.Menus.find(x => x.Code === code);
      if(!activMenu) {
      return;
    }
    var selectedItemMenu = this.allItems(activMenu).find(x => x.Id == itemId);


    this.ActionClick.emit(selectedItemMenu);

  }

  /**
   * Sur clic icone export connecté statuts
   */
  public onIconConnectedStatsClick() {
    let val: itemValue = new itemValue();
    val.Model = 'OpenConnectedStatesPopin';
    val.Value = "true";
    this.OtherActionClick.emit(val);
    this.RemoveFlashIconConnectedStates();
  }

  /**suppression css qui faire clignoter le state */
  private RemoveFlashIconConnectedStates() {
    this.classExportConnectedState = "";
  }


  /**Maj css sur icone export connected state selon statut */
  updateExportConnectedStateFlash(): void {

    this.precizionExport.onChangeUpdateStatePollingLastStatus().subscribe(
      stateChange => {

        if (this.precizionExport.IsPopinConnectedStatesOpen() == false) {
          this.classExportConnectedState =
            this.precizionExport?.IncludConnectedStateChanges === true
              ? 'ic_export_connected_changed_states'
              : '';
        }else{
          this.RemoveFlashIconConnectedStates();
          this.precizionExport.RemoveConnectedStateChanges();
        }

      }
    )

  }




  /**
   * Gestion de la selection d'un element dans le menu
   * @param event
   */
  public itemMenuClick(event: any) {
    var code = event.target.id.split("_")[0];
    var itemId = event.target.id.split("_")[1];

    //si clique sur le TEXTE et non la checkbox alors s il a pas de itemId ni code, donc on gère ici
    if (!itemId && !code && event.target && event.target.parentElement && event.target.parentElement.id) {

      var codeParent = event.target.parentElement.id.split("_")[0];
      var itemIdParent = event.target.parentElement.id.split("_")[1];

      if (codeParent && itemIdParent) {
        code = codeParent;
        itemId = itemIdParent;
      }

    }
    var activMenu = this.Menus.find(x => x.Code === code);
    if (!activMenu) {

      return;
    }

    this.changedMenus[activMenu.Code] = true;
    

    // Verification que la selection appartient au même groupe que les élèments précédement selectionnés
    if (!activMenu.MultipleGroupSelected && activMenu.Checkable == menuType.MultiSelectable) {


      var groupItemSelected = activMenu.GroupItems.filter(g => g.Items.filter(i => i.Checked).length > 0);

  
      if (groupItemSelected != null && groupItemSelected.length > 0) {

         this._currentGroupCoopSelected = groupItemSelected[0].Id;

         var newGroupSelected = activMenu.GroupItems.filter(g => g.Items.filter(i => i.Id == itemId).length > 0);
        let isChangingCoop=newGroupSelected != null && newGroupSelected.length > 0 && newGroupSelected[0].Id != groupItemSelected[0].Id;
        

        if(!isChangingCoop &&activMenu.MultiMaxSelectable != null && activMenu.MultiMaxSelectable>0) {
          if(groupItemSelected[0].Items.filter(i => i.Checked).length >= activMenu.MultiMaxSelectable){
              if(groupItemSelected[0].Items.find(i => i.Id == itemId) != undefined && groupItemSelected[0].Items.find(i => i.Id == itemId)?.Checked == false){
                          return false;
              }
          }
          
        }

       
        if (isChangingCoop) {
          /*Permet la selection d exploitation d une autre coop en deselectionnant les autres */
          this.UnselectByGroupExcepte(code, newGroupSelected[0].Id);
          //on remonte sur le haut du menu pour que la nouvelle sélection selon la coop soit visible
          this.ScrollMenuToTheTop(event)
          
        }
      }else{
         this._currentGroupCoopSelected = null;
           var newGroupSelected = activMenu.GroupItems.filter(g => g.Items.filter(i => i.Id == itemId).length > 0);
           if(newGroupSelected && newGroupSelected.length>0 &&activMenu && activMenu.Code == this.MenuFarmCode){
              //on remonte sur le haut du menu pour que la nouvelle sélection selon la coop soit visible
              if(activMenu?.GroupItems?.length>1){
                if(activMenu.GroupItems[0].Id !== newGroupSelected[0].Id){
                  //si on est pas sur le 1e groupement sélectionné on remonte le scroll
                  this.ScrollMenuToTheTop(event)
                }
                  
              }
             
           }
      
      }
    }

    if (activMenu.Checkable == menuType.Mono) {
      //il ne repositionne pas correctement la selection au dessus si >= 6 campagnes présente donc timeout pour refresh
      let forceRefresh = this.allItems(activMenu).length >= 6;

      let fndMenu = this.Menus.find(x => x.Code === code) != undefined

      if (forceRefresh && fndMenu) {
         
        this.Menus.find(x => x.Code === code).MonoRefresh = true;
      }

      this.allItems(activMenu).forEach(itemmenu => {
        itemmenu.Checked = itemmenu.Id == itemId;
      });
      if (forceRefresh && fndMenu) {
        setTimeout(() => {
          this.Menus.find(x => x.Code === code).MonoRefresh = null;
        }, 10);
      }
    } else {
      var selectedItemMenu = this.allItems(activMenu).find(x => x.Id == itemId);
      if(selectedItemMenu)
      selectedItemMenu.Checked = !selectedItemMenu.Checked;

     
    }

    
    if(activMenu && activMenu.Checkable == menuType.MultiSelectable) {
     //on propage la selection quand il en sort
    }
    else{
       this.EmitMenuSelectionChanges(activMenu);
    }
  }

  public onLogout() {
    this.logout.emit();
  }

  /**
   * emit menu selection changes
   * @param menu 
   */
  private EmitMenuSelectionChanges(menu:menuItem){
    
    this.SelectionChanged.emit(menu);
    this.changedMenus[menu.Code] = false;
  }

  /**Scroll le menu to the top */
  private ScrollMenuToTheTop(menuEvent:any){
     let scrollComponent = this.IsMobile ? '.list-menu' : '.ddl-filter';
            var menuItemsContainer = menuEvent.target.closest(scrollComponent);
            if (menuItemsContainer) {
              setTimeout(() => {
                menuItemsContainer.scroll({top: 0,behavior: 'smooth'}); 
              }, 100);
            }
  }


  /**
   * Retourne le terme de recherche ou une chaîne vide
   */
  public getSearchTerm(menuCode: string): string {
    return this.searchTerms[menuCode] || '';
  }

  /**
 * Gestion du changement de terme de recherche
 */
  public onSearchChange(menuCode: string, value: string): void {
    this.searchTerms[menuCode] = value || '';
  }

  /**
   * Retourne les groupes filtrés selon le terme de recherche, triés par sélection
   */
  public getFilteredGroups(menu: menuItem): groupItem[] {
    const searchTerm = this.searchTerms[menu.Code];
    let filteredGroups: groupItem[];

    if (!searchTerm) {
      // Sans recherche, afficher tous les groupes
      filteredGroups = menu.GroupItems;
    } else {
      // Avec recherche, filtrer les groupes
      filteredGroups = menu.GroupItems.filter(group => {
        // Inclure le groupe si son titre correspond à la recherche
        const titleMatches = group.Title.toLowerCase().includes(searchTerm.toLowerCase());

        // OU si au moins un de ses items (sélectionné ou non) correspond à la recherche
        const hasMatchingItems = group.Items.some(item =>
          item.Value.toLowerCase().includes(searchTerm.toLowerCase())
      );

        return titleMatches || hasMatchingItems;
      });
    }

    // Trier les groupes : ceux avec des éléments sélectionnés d'abord
    const groupsWithSelected = filteredGroups.filter(group =>
      group.Items.some(item => item.Checked)
    );
    const groupsWithoutSelected = filteredGroups.filter(group =>
      !group.Items.some(item => item.Checked)
    );

    return [...groupsWithSelected, ...groupsWithoutSelected];
  }

  /**
   * Vérifie si un groupe a des éléments non-sélectionnés à afficher dans la liste principale
   */
  public shouldShowGroupTitle(group: groupItem, menuCode: string): boolean {
    const searchTerm = this.searchTerms[menuCode];

    if (!searchTerm) {
      // Sans recherche, toujours afficher le titre
      return true;
    }
    const searchTermText = searchTerm.toLowerCase();
    // Avec recherche, afficher le titre seulement s'il y a des items non-sélectionnés à afficher
    if (group.Title.toLowerCase().includes(searchTermText)) {
      return group.Items.some(item => !item.Checked);
    }

    return group.Items.some(item =>
      !item.Checked && item.Value.toLowerCase().includes(searchTermText)
    );
  }

  /**
   * Retourne les éléments filtrés d'un groupe pour la section principale
   * Exclut les éléments sélectionnés UNIQUEMENT s'ils sont déjà affichés dans la section dédiée
   */
  public getFilteredItemsInGroup(group: groupItem, menuCode: string): itemValue[] {
    const searchTerm = this.searchTerms[menuCode];

    if (!searchTerm) {
      // Sans recherche : NE PAS afficher les items sélectionnés ici
      // car ils sont déjà affichés dans la section "Éléments sélectionnés"
      return group.Items.filter(item => !item.Checked);
    } else {
      // Avec recherche
      const searchTermText = searchTerm.toLowerCase();
      const titleMatches = group.Title.toLowerCase().includes(searchTermText);

      if (titleMatches) {
        // Titre correspond : afficher items non-sélectionnés uniquement
        return group.Items.filter(item => !item.Checked);
      } else {
        // Filtrer par valeur ET exclure les sélectionnés
        return group.Items.filter(item =>
          !item.Checked && item.Value.toLowerCase().includes(searchTermText)
        );
      }
    }
  }

  /**
  * Vérifie s'il y a des éléments non-sélectionnés à afficher dans les résultats de recherche
  */
  public hasUnselectedResults(menu: menuItem): boolean {
    const searchTerm = this.searchTerms[menu.Code];

    if (!searchTerm) {
      return true;
    }

    return this.getFilteredGroups(menu).some(group => {
      return this.getFilteredItemsInGroup(group, menu.Code).length > 0;
    });
  }

  /**
   * Vérifie si un groupe contient des éléments sélectionnés
   */
  public hasSelectedItemsInGroup(group: groupItem): boolean {
    return group.Items.some(item => item.Checked);
  }

  /**
   * Retourne les éléments sélectionnés d'un groupe
   */
  public getSelectedItemsInGroup(group: groupItem): itemValue[] {
    return group.Items.filter(item => item.Checked);
  }

  /**
   * Met en évidence le terme recherché dans le texte
   */
  public highlightSearchTerm(text: string, searchTerm: string): string {
    if (!searchTerm) {
      return text;
    }

    const regex = new RegExp(`(${searchTerm})`, 'gi');
    return text.replace(regex, '<mark>$1</mark>');
  }

  /**
   * Permet la déselection des éléments sélectionnés dans les Autres Groupes que celui indiqué sélectionné (groupIDSelected)
   * @param menuCode code de menu
   * @param groupIDSelected déselection de tout ce qui nest pas sur cet id
   */
  private UnselectByGroupExcepte(menuCode: string, groupIDSelected: string) {
    var activMenu = this.Menus.find(x => x.Code === menuCode);
    if (activMenu != null && activMenu.GroupItems != null && activMenu.GroupItems.length > 0) {
      /* on désélectionne les selection selon le group */
      activMenu.GroupItems.forEach(grp => { if (grp.Id != groupIDSelected) { grp.Items.forEach(t => { if (t.Checked) { t.Checked = false } }) } });
    }
  }

  /**
   * Permet la désélection de tous les éléments du menu farm
   */
  public ClearFarmSelection() {
    var farmMenu = this.Menus.find(x => x.Code === this.MenuFarmCode);
    if(farmMenu){
      var groupItemSelected = farmMenu.GroupItems.filter(g => g.Items.filter(i => i.Checked).length > 0);
      if(groupItemSelected?.length>0){
       this.UnselectByGroupExcepte(this.MenuFarmCode,"0");
       this.changedMenus[farmMenu.Code]=true;
     
      }
    }
  }

  /**
   * Expend collapse liste filtre menu mobile
   */
  public toggleMobileMenu(code: string): void {
    this.collapsedMenus[code] =!this.collapsedMenus[code];
  }

  /**
   * Permet, sur mobile, de fermer le menu de filtres
   */
  public togglePopupFilter() {
    this.showPopupFilter = !this.showPopupFilter;
    this.eventEmitterService.emitTogglePopupFilterClick(this.showPopupFilter);
  }
}
